<template>
  <div class="footer-card"
       v-if="falg">
    <TitleCard title="热门问题"
               :showMore="false"> </TitleCard>
    <div class="footer-content">
      <div class="content-item">
        <span class="content-title">
          <IconWrap :width="20"
                    :height="19"
                    url="/static/homeIcon/tishen.png"></IconWrap>
          想提升专利质量？
        </span>
        <div class="content-detail">
          <div v-for="item in qualityList"
               :key="item.id">
            <span @click="handleClick(item.id, item.title)">{{ item.title }} ></span>
          </div>
        </div>
      </div>
      <div class="right-content">
        <div class="right-item">
          <span class="content-title">
            <IconWrap :width="20"
                      :height="19"
                      url="/static/homeIcon/panduan.png"></IconWrap>
            想判断专利价值?
          </span>
          <div class="content-detail">
            <div v-for="item in worthList"
                 :key="item.id"
                 @click="handleTips">
              <span>{{ item.title }} ></span>
            </div>
          </div>
        </div>
        <div class="right-item">
          <span class="content-title">
            <IconWrap :width="20"
                      :height="19"
                      url="/static/homeIcon/genzhong.png"></IconWrap>
            想跟踪专利信息?
          </span>
          <div class="content-detail">
            <div v-for="item in infoList"
                 :key="item.id"
                 @click="handleMessage(item.id)">
              <span>{{ item.title }} ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { qualityList, worthList, infoList } from './configs/config.js'
import { mapGetters } from 'vuex'
import { getMenuList } from '@/api/back.js'

export default {
  data() {
    return {
      qualityList,
      worthList,
      infoList,
      falg: null
    }
  },
  computed: {
    ...mapGetters('headerMenu', ['setUpdateMenuList']),
    menuList() {
      return this.setUpdateMenuList
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      let params = {
        pageNum: 1,
        pageSize: 10,
        code: 'hotProblem'
      }
      const { data } = await getMenuList()
      data.forEach((item) => {
        if (item.code === params.code) {
          if (item.status === '0') {
            this.falg = true
          } else {
            this.falg = false
          }
        }
      })
      console.log(this.falg, 'this.falg')
      if (this.falg) {
        this.$store
          .dispatch('articleDetail/getHomeList', params)
          .then((res) => {
            this.qualityList.forEach((item) => {
              res.rows.forEach((ele) => {
                if (item.title === ele.title) {
                  item.id = ele.id
                }
              })
            })
          })
      }
      console.log(data, 'menuList')
      console.log(this.qualityList, 'this.qualityList')
    },

    // 处理卡片点击item项跳转
    handleClick(id, name) {
      if (id == 6) {
        this.$router.push({
          name: `resourceNavigation`,
          query: {
            code: 'zydh',
            selectedId: this.commonHandle('zydh', 'xwshsxx')
          }
        })
      } else {
        this.$router.push({ path: `/index/hotNews?id=${id}&name=${name}` })
      }
    },
    handleTips() {
      this.$message.warning('功能开发中，敬请期待')
    },
    handleMessage(id) {
      if (id === 1) {
        this.$message.warning('功能开发中，敬请期待')
      } else {
        this.$router.push({
          name: 'informationService',
          query: {
            code: 'xinxiServer',
            selectedId: this.commonHandle('xinxiServer', 'trainingLectures')
          }
        })
      }
    },
    commonHandle(codeOne, codeTwo) {
      let obj = this.menuList.filter((res) => res.code === codeOne)
      let selectedId
      obj[0].children.forEach((res) => {
        if (res.code === codeTwo) {
          selectedId = res.id
        }
      })
      return selectedId
    }
  }
}
</script>

<style></style>
